import z from 'zod';

export const GenderType = {
    Male: 'Male',
    Female: 'Female',
    Mixed: 'Mixed',
} as const;
export type GenderType = (typeof GenderType)[keyof typeof GenderType];

export const GenderEnum = z.enum(GenderType);
